import { createRouter, createWebHistory } from 'vue-router'
import { scrollToAnchorWhenReady, scrollToAnchorImmediate } from '@/utils/anchorScroll'
import {getToken} from '@/utils'
import { resolveLegacyRedirect } from './legacyRedirects'

if (typeof window !== 'undefined') {
  history.scrollRestoration = 'manual'
}

export const menuList = [
  // {
  //   path: '/home',
  //   name: 'home',
  //   meta: {
  //     title: '首页',
  //     isSettings: true,
  //   },
  //   component: () => import('@/views/Home/Home.vue'),
  // },
  {
    path: '/about',
    name: 'about',
    meta: {
      title: '关于亦芯',
      isSettings: true,
      list: [
        { text: '企业简介', value: '#companyProfile' },
        { text: '企业使命', value: '#corporateMission' },
        { text: '发展历程', value: '#developmentHistory' },
        { text: '宣传片', value: '#brandVideo' },
        { text: '集团荣誉', value: '#groupHonors' },
        { text: '我们的动态', value: '#companyNews' },
        { text: '预约咨询', value: '#appointment' },
      ]
    },
    component: () => import('@/views/about/Index.vue'),
  },
  {
    path: '/service',
    name: 'service',
    meta: {
      title: '亦芯服务',
      isSettings: true,
      list: [
        { text: '亦芯咨询', value: '#consultingService' },
        { text: '亦芯营销', value: '#marketing' },
        { text: '亦芯科技', value: '#technology' },
        { text: '合作品牌', value: '#cooperativeBrand' },
      ]
    },
    component: () => import('@/views/service/Index.vue'),
  },
  {
    path: '/culture',
    name: 'culture',
    meta: {
      title: '企业文化',
      isSettings: true,
      list: [
        { text: '人才培养', value: '#talentCultivation' },
        { text: '办公环境', value: '#officeEnvironment' },
        { text: '文化活动', value: '#culturalActivities' },
        { text: '加入亦芯', value: '#socialRecruitment' },
      ]
    },
    component: () => import('@/views/culture/Index.vue'),
  },
]

export const routes = [
  {
    path: '/',
    redirect: '/about',
  },
  {
    path: '/',
    component: () => import('@/views/Home/pageHome.vue'),
    children: menuList
  },
  {
    path: '/c2V0dGluZ3M=',
    component: () => import('@/views/settings/Index.vue'),
  },
  {
    path: '/consultation-login',
    name: 'ConsultationLogin',
    meta: {
      title: '登录',
    },
    component: () => import('@/views/leads/Login.vue'),
  },
  {
    path: '/consultation-records',
    name: 'ConsultationRecords',
    meta: {
      title: '咨询记录',
      requiresAuth: true,
    },
    component: () => import('@/views/leads/Index.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/views/NotFound.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      const hash = to.hash
      scrollToAnchorWhenReady(hash, 106, { timeoutMs: 5000 })
      return false
    }

    return { top: 0 }
  }
})

router.beforeEach((to) => {
  const legacyRedirect = resolveLegacyRedirect(to)
  if (legacyRedirect) return legacyRedirect

  if (to.meta.requiresAuth && !getToken()) {
    return {
      name: 'ConsultationLogin',
      query: {
        redirect: to.fullPath,
      },
    }
  }

  if (to.name === 'ConsultationLogin' && getToken()) {
    return {name: 'ConsultationRecords'}
  }

  return true
})

export function handleHashScroll(hash) {
  scrollToAnchorImmediate(hash, 106)
}

export default router
